import React from "react";

export default class SingleSelectComponent extends React.Component {
  constructor(props) {
    super(props);
    this.selectId = `${Math.round(Math.random() * 10 ** 10)}`;
  }

  render() {
    const { id, value, editable, options } = this.props;
    return (
      <select
        id={id || this.selectId}
        style={
          !editable === true
            ? {
                background: "inherit",
                WebkitAppearance: "button",
                appearance: "button",
              }
            : {
                background: "",
                WebkitAppearance: "button",
                appearance: "button",
              }
        }
        value={value}
        disabled={!editable}
        onChange={event => this.props.onChangeData(event.target.value)}
        data-test="singleselectcomponent-options-select">
        {options.map(data => (
          <option>{data}</option>
        ))}
      </select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/CustomGridTypeComponents/SingleSelectComponent.js